import auditTrailFiltersSignal, {
	setAuditTrailFilters,
} from '@UI/Pages/Administration/AuditTrail/Filters/Signals/auditTrailFiltersSignal';
import { fieldWithoutMarginStyles } from '@Guidelines/Theme/commonPassthrough';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import type UserView from '@UI/Store/Users/Views/UserView';
import { Dropdown } from '@verclam/ui-kit';

type Props = {
	readonly users: readonly UserView[] | null;
	readonly withLabel?: boolean;
};

const ActorFilter: React.FC<Props> = ({ users, withLabel = false }) => {
	const currentFilters = useSignalValue(auditTrailFiltersSignal);

	const handleChange = React.useCallback((selectedId: number | null) => {
		setAuditTrailFilters(auditTrailFiltersSignal.peek().setActorUserId(selectedId));
	}, []);

	return (
		<Dropdown<number>
			name="auditTrailActor"
			label="Acteur"
			isLabelHidden={!withLabel}
			placeholder="Tous les acteurs"
			options={users ?? []}
			optionLabel="fullName"
			optionValue="id"
			loading={users === null}
			showClear
			value={currentFilters.actorUserId}
			onChange={handleChange}
			pt={fieldWithoutMarginStyles}
		/>
	);
};

export default ActorFilter;
